module.exports = __webpack_public_path__ + "img/top-b-back1.099b7bef.png";